import { render, staticRenderFns } from "./hpCollage.vue?vue&type=template&id=3f82395a&scoped=true&"
import script from "./hpCollage.vue?vue&type=script&lang=js&"
export * from "./hpCollage.vue?vue&type=script&lang=js&"
import style0 from "./hpCollage.vue?vue&type=style&index=0&id=3f82395a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f82395a",
  null
  
)

export default component.exports